module.exports = __webpack_public_path__ + "img/gamma3_icon.bcaf9c3c.png";